import isIntuit from "Intuit/isIntuit";
import isSquare from "Square/isSquare";
// currently only show user settings if user is based in california
export const showUserSettings = (zip_code: string): boolean => parseInt(zip_code, 10) >= 90000 && parseInt(zip_code, 10) <= 96699 && (isIntuit() || isSquare());
